import { StyleSheet } from 'react-native';

import { Fonts } from '../Themes';

export default StyleSheet.create({
  containerScroll: theme => ({
    flex: 1,
    height: 10,
    backgroundColor: theme.colors.backgroundColor,
  }),
  container: {
    paddingTop: 50,
    paddingBottom: 40,
    justifyContent: 'space-between',
    paddingHorizontal: 30,
  },
  closeIcon: {
    alignItems: 'flex-end',
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  headerTitle: {
    fontSize: 17,
    ...Fonts.type.bold,
  },
  bodyWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  image: {
    marginBottom: 10,
  },
  header: {
    fontSize: 30,
    marginBottom: 25,
    fontWeight: 'bold',
    fontFamily: Fonts.type.VFFont,
    textAlign: 'center',
  },
  description: {
    textAlign: 'center',
    fontFamily: Fonts.type.VFFont,
    fontSize: 17,
    lineHeight: 22,
  },
  proceed: {
    marginBottom: 17,
  },
  outerContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 10,
    elevation: 5,
  },
  buttonsWrappers: {
    justifyContent: 'space-between',
  },
  scrollMarginStyle: isScrollable => ({
    marginBottom: isScrollable ? 40 : 0,
  }),
  overlayLottie: {
    height: 156,
    width: 156,
  },
});
